import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Modal,
  Card,
  CardContent,
  CardActions,
  Button,
  CardHeader,
  Divider,
  Typography,
  Box,
  LinearProgress
} from '@material-ui/core';
import { SubjectAreaContents, AddSubjectAreaContent, Alert } from 'components';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 760,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  content: {
    padding: theme.spacing(2)
  },
  addContentButton: {
    marginTop: theme.spacing(2)
  }
}));

const AnnotateWalksModal = props => {
  const {
    name,
    walkDescription,
    processing,
    open,
    onClose,
    className,
    subjectAreaContents,
    objectTypes,
    subjectAreaContent,
    handleSubjectAreaContentFieldChange,
    handleSaveSubjectAreaContent,
    handleDeleteSubjectAreaContent,
    handleSave,
    ...rest
  } = props;

  const [addSubjectAreaContentOpen, setAddSubjectAreaContentOpen] = useState(
    false
  );

  const classes = useStyles();

  const handleClose = () => {
    onClose();
  };

  if (!open) {
    return null;
  }

  const handleOpenAddSubjectAreaContent = () => {
    setAddSubjectAreaContentOpen(true);
  };

  return (
    <>
      <Modal onClose={handleClose} open={open}>
        <Card {...rest} className={clsx(classes.root, className)}>
          <CardHeader title="Annotate Walks" />
          <Divider />
          {processing && <LinearProgress />}
          <Box p={2}>
            <Alert
              style={{ marginBottom: 16 }}
              severity="info"
              message={`Changes will be applied to ${walkDescription} and will overwrite any existing subject area content annotations`}
            />
            <Typography variant="body1" color="textPrimary">
              {name}
            </Typography>
          </Box>
          <Divider />
          <CardContent className={classes.content}>
            <SubjectAreaContents
              subjectAreaContents={subjectAreaContents}
              onDelete={handleDeleteSubjectAreaContent}
            />
            <Button
              className={classes.addContentButton}
              variant="contained"
              size="small"
              onClick={handleOpenAddSubjectAreaContent}>
              Add Content
            </Button>
          </CardContent>
          <CardActions className={classes.actions}>
            <Button onClick={handleClose} variant="contained">
              Cancel
            </Button>
            <Button onClick={handleSave} color="primary" variant="contained">
              Apply
            </Button>
          </CardActions>
        </Card>
      </Modal>

      <AddSubjectAreaContent
        hideNew={true}
        open={addSubjectAreaContentOpen}
        onClose={() => setAddSubjectAreaContentOpen(false)}
        subjectAreaContent={subjectAreaContent}
        objectTypes={objectTypes}
        onFieldChange={handleSubjectAreaContentFieldChange}
        onSave={() => {
          setAddSubjectAreaContentOpen(false);
          handleSaveSubjectAreaContent();
        }}
      />
    </>
  );
};

AnnotateWalksModal.propTypes = {
  name: PropTypes.string,
  walkDescription: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired
};

AnnotateWalksModal.defaultProps = {
  open: false,
  objectTypes: [],
  subjectAreaContents: []
};

export default AnnotateWalksModal;
